__turbopack_context__.v({
  "className": "public_sans_4bce4d0-module__xtBAla__className",
  "variable": "public_sans_4bce4d0-module__xtBAla__variable",
});
